import './styles/App.css';
import { Route, Routes } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop'

import Navbar from "./components/NavBar"
import Home from "./Main"
import Experience from "./Experiences"
import Projects from "./Projects"
import CV from "./CV"
import CVShort from "./CVShort"

import { lazy, Suspense } from 'react';
import { projectMeta } from "./projectMeta";

function App() {
  return (
    <>
      <Navbar></Navbar>
      <div className='container'>
        <ScrollToTop />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/Experience' element={<Experience />} />
          <Route path='/Projects' element={<Projects />} />
          <Route path='/CV' element={<CV />} />
          <Route path='/CVShort' element={<CVShort />} />
          {projectMeta.map(({ path, file }, i) => {
            const Component = lazy(() => import(`./Projects/${file}`));
            return (
              <Route
                key={i}
                path={path}
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <Component />
                  </Suspense>
                }
              />
            );
          })}
        </Routes>
      </div>
    </>
  );
}

export default App;
